import { styled } from '@mui/material/styles';
import ArrowDropDown from '@raisin/components-lib/Icons/ArrowDropDown';
export const ToggleWrapper = styled('div')(({ theme, inHeader }) => (Object.assign({ position: 'relative', width: 'fit-content' }, (inHeader
    ? {
        [theme.breakpoints.down('md')]: {
            position: 'static',
        },
    }
    : {
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
        },
    }))));
export const CountryToggle = styled('button')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: theme.spacing(9),
    padding: theme.spacing(2.75, 3),
    fontFamily: 'inherit',
    fontSize: theme.typography.subtitle2.fontSize,
    fontWeight: theme.typography.subtitle2.fontWeight,
    lineHeight: theme.spacing(4.5),
    color: theme.palette.black100.main,
    cursor: 'pointer',
    backgroundColor: theme.palette.white.main,
    border: `1px solid ${theme.palette.black20.main}`,
    borderRadius: `${theme.shape.borderRadius}px`,
    '& svg': {
        height: theme.spacing(4.25),
    },
}));
export const CountryName = styled('span')(({ theme }) => ({
    margin: theme.spacing(0, 2, 0, 2.5),
    color: theme.palette.black100.main,
}));
export const StyledArrowDropDownRoundedIcon = styled(ArrowDropDown)(({ theme, isOpen, direction }) => ({
    width: theme.spacing(7.5),
    height: theme.spacing(7.5),
    transition: '0.25s',
    rotate: isOpen === (direction === 'up') ? '0' : '180deg',
}));
export const CountryPickerDropDown = styled('span')(({ theme, isOpen, direction, align, inHeader }) => (Object.assign(Object.assign(Object.assign(Object.assign({ position: 'absolute', zIndex: theme.zIndex.drawer, display: 'grid', gridTemplateColumns: 'auto auto', gap: theme.spacing(2, 4), padding: theme.spacing(6), visibility: isOpen ? 'visible' : 'hidden', background: theme.palette.white.main, borderRadius: `${theme.shape.borderRadius}px`, boxShadow: '0 1px 6px rgb(70 70 70 / 8.63%)', opacity: isOpen ? 1 : 0, transition: '0.25s' }, (direction === 'up'
    ? {
        bottom: 'calc(100% + 5px)',
    }
    : {
        top: 'calc(100% + 5px)',
    })), (align === 'left'
    ? {
        right: 0,
    }
    : {
        right: theme.spacing(-4),
    })), (inHeader
    ? {
        [theme.breakpoints.down('md')]: {
            left: theme.spacing(2),
            right: theme.spacing(2),
        },
    }
    : {
        [theme.breakpoints.down('md')]: {
            left: theme.spacing(-2),
            right: theme.spacing(-2),
        },
    })), { [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'auto',
        rowGap: theme.spacing(3),
        padding: theme.spacing(4, 5.5),
    } })));
export const CountryCard = styled('a')(({ theme, $isActive }) => ({
    display: 'grid',
    gridTemplateColumns: '26px 1fr',
    columnGap: theme.spacing(4),
    alignItems: 'center',
    minWidth: '200px',
    padding: theme.spacing(3, 3.5),
    fontSize: theme.typography.subtitle2.fontSize,
    fontWeight: theme.typography.subtitle2.fontWeight,
    lineHeight: '18px',
    color: 'inherit',
    textDecoration: 'none',
    pointerEvents: $isActive ? 'none' : 'auto',
    background: $isActive ? theme.palette.blue10.main : theme.palette.white.main,
    border: `1px solid ${$isActive ? theme.palette.blue80.main : theme.palette.black10.main}`,
    borderRadius: `${theme.shape.borderRadius}px`,
    transition: '0.25s',
    '&:hover': {
        background: theme.palette.blue10.main,
        border: `1px solid ${theme.palette.blue80.main}`,
    },
}));
export const FlagWrapper = styled('div')(({ theme }) => ({
    display: 'inline-flex',
    overflow: 'hidden',
    border: `1px solid ${theme.palette.black20.main}`,
    borderRadius: `${theme.shape.borderRadius}px`,
    '& svg': {
        width: theme.spacing(6),
        height: 'auto',
    },
}));
//# sourceMappingURL=styles.js.map